import React from 'react'

import ItemCard from '../itemCard'

import styles from './gridVideo.module.css'

const GridVideo = ({items, viewType, videoMuted, currentSite, itemDecorator}) => {
  return (
    <ul className={styles.grid}>
      {
        items.map((item, index) => {
          return (
            <li className={styles.result} key={item.id}>
              <ItemCard
                videoMuted={videoMuted}
                currentSite={currentSite}
                viewType={viewType}
                itemProps={itemDecorator(item, index)}
              />
            </li>
          )
        })
      }
    </ul>
  )
}

export default GridVideo



// WEBPACK FOOTER //
// ./client/components/productList/gridVideo.js